import Box from '@mui/material/Box';
import Button from 'common/components/Elements/Button/Button';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import { getCommand } from 'core/redux/actions/command/commandActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useCallback,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandGet({ command, small }: ComponentProps) {
  const {
    id, title, active, shortcut, action, label,
  } = command;
  const persistingCommand = useSelector((state: ApplicationState) => state.page.persistingCommand);
  const persisting = persistingCommand && persistingCommand.id === id;

  const dispatch = useDispatch<AppThunkDispatch>();

  const shortcutTrigger = useShortcut(...(shortcut || []));

  const handleClick = useCallback(() => {
    dispatch(getCommand(command));
  }, [dispatch, command]);

  useEffect(() => {
    if (shortcut && shortcutTrigger) {
      handleClick();
    }
  }, [shortcut, shortcutTrigger, handleClick]);

  return (
    <Box position="relative" display="inline-block">
      <Button
        action={action || 'tertiary'}
        className={classes.command}
        title={title}
        onClick={() => handleClick()}
        small={small}
        disabled={active === false || persisting}
        e2eId={id}
        buttonIcon={label === undefined}
      >
        <CommandLinkContent command={command} />
      </Button>
      {persisting && (
        <ButtonLoading />
      )}
    </Box>
  );
}

export default CommandGet;
